import axios from 'axios';
import { postFiles } from '../util/axios';

export const apiGetExperiences = ({ pageSize, page, sorted, filtered }) => {
  const sort = sorted.map((column) => `${column.id},${column.desc ? 'desc' : 'asc'}`);
  const filter = filtered.map((column) => `${column.id},${column.value}`);
  return axios.get(`/api/experiences`, { params: { limit: pageSize, page, sort, filter }, skipLoader: true });
};
export const apiAllExperiences = ({ pageSize, page, sorted, filtered }) => {
  const sort = sorted.map((column) => `${column.id},${column.desc ? 'desc' : 'asc'}`);
  const filter = filtered.map((column) => `${column.id},${column.value}`);
  return axios.get(`/api/admin/experiences`, { params: { limit: pageSize, page, sort, filter }, skipLoader: true });
};

export const apiGetExperiencesFromRegistration = ({ registrationId }) =>
  axios.get(`/api/registration/${registrationId}/experiences`);

export const apiGetExperience = (id) => axios.get(`/api/experience/${id}`);
export const apiAddExperience = (registrationId, payload) =>
  postFiles(`/api/registration/${registrationId}/experience`, payload);
export const apiUpdateExperience = (registrationId, { id, ...payload }) =>
  axios.patch(`/api/registration/${registrationId}/experience/${id}`, payload);
export const apiDeleteExperience = (registrationId, id) =>
  axios.delete(`/api/registration/${registrationId}/experience/${id}`);

export const apiApproveExperience = (id, payload) => axios.post(`/api/admin/experience/${id}/approve`, payload);
export const apiRejectExperience = (id, payload) => axios.post(`/api/admin/experience/${id}/reject`, payload);
export const apiSendExperienceValidation = (payload) => axios.post(`/api/admin/experience/validation`, payload);

export const apiAddFile = ({ id, registrationId }, payload) =>
  postFiles(`/api/registration/${registrationId}/experience/${id}/file`, payload);

// export const apiApproveCEU = (id, payload) => axios.post(`/api/admin/ceu/${id}/approve`, payload);
// export const apiRejectCEU = (id, payload) => axios.post(`/api/admin/ceu/${id}/reject`, payload);
